/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Batch } from './Batch';
import {
    BatchFromJSON,
    BatchFromJSONTyped,
    BatchToJSON,
} from './Batch';

/**
 * 
 * @export
 * @interface SelectedBatch
 */
export interface SelectedBatch {
    /**
     * 
     * @type {Batch}
     * @memberof SelectedBatch
     */
    batch: Batch;
    /**
     * Ausgewählte Menge aus dieser Charge
     * @type {number}
     * @memberof SelectedBatch
     */
    quantity: number;
}

/**
 * Check if a given object implements the SelectedBatch interface.
 */
export function instanceOfSelectedBatch(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "batch" in value;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function SelectedBatchFromJSON(json: any): SelectedBatch {
    return SelectedBatchFromJSONTyped(json, false);
}

export function SelectedBatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectedBatch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batch': BatchFromJSON(json['batch']),
        'quantity': json['quantity'],
    };
}

export function SelectedBatchToJSON(value?: SelectedBatch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch': BatchToJSON(value.batch),
        'quantity': value.quantity,
    };
}

